<template lang="html">

  <section class="politica-de-cookies pad-sec">

    <div class="container">
      <h3 class="title title-36 ">Pol&iacute;tica de Cookies</h3>
      <p>A trav&eacute;s de la presente Pol&iacute;tica de Cookies Ajusa garantiza el cumplimiento de la normativa aplicable. La presente Pol&iacute;tica de Cookies, podr&aacute; ser modificada en cualquier momento por razones legales o normativas, por motivos t&eacute;cnicos o por cambios en la prestaci&oacute;n de los servicios del Sitio Web. Cuando esto ocurra y con el objetivo de avisarle, lo publicaremos en el propio Sitio. Si contin&uacute;a utilizando los servicios del Sitio Web, entenderemos que ha aceptado las modificaciones introducidas. <br />
       <br />
       <strong>1.&iquest;Qu&eacute; son las cookies?</strong><br />
       
      
       <br />
      Una cookie es un pequeño archivo de información que se guarda en su navegador cada vez que visita nuestra web.  <br />
       <br />
      La utilidad de las cookies es guardar el historial de su actividad en nuestra para que, cuando la visite nuevamente, pueda identificarle y configurar su contenido en base a sus hábitos de navegación, identidad y preferencias. Fuera de estas cookies, las cookies que se clasifican como necesarias se almacenan en su navegador, ya que son esenciales para el funcionamiento de las funcionalidades básicas del sitio web.<br />
       <br />
       Pueden ser aceptadas, rechazadas, bloqueadas y borradas, según desee. Aunque la exclusión de algunas de estas cookies puede afectar su experiencia de navegación.<br />
       <br />
       <strong>2. Tipolog&iacute;a de cookies empleadas</strong>.<br />
       <br />
       A continuaci&oacute;n te ofrecemos informaci&oacute;n sobre el tipo de cookies utilizadas en http://www.ajusath.es y la finalidad de las mismas: <br />
       <br />
     </p>
     <ul>
       <li>Cookies de sesi&oacute;n: son un tipo de cookies dise&ntilde;adas y utilizadas para recabar y almacenar datos mientras el usuario accede a una p&aacute;gina web. Como su propio nombre indica, estas cookies se almacenan en su terminal hasta que finalice la sesi&oacute;n de navegaci&oacute;n del usuario.</li>
       <li>Cookies t&eacute;cnicas de navegaci&oacute;n: Son aqu&eacute;llas que permiten al usuario la navegaci&oacute;n a trav&eacute;s de la p&aacute;gina web y la utilizaci&oacute;n de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tr&aacute;fico y la comunicaci&oacute;n de datos. Caducan al cerrar la sesi&oacute;n.</li>
       <li>Cookies anal&iacute;ticas: son un tipo de cookies dise&ntilde;adas y utilizadas para el seguimiento y an&aacute;lisis del comportamiento de los usuarios. Este tipo de cookies ofrecen al titular de la p&aacute;gina la medici&oacute;n de la actividad en el sitio web a trav&eacute;s de informaci&oacute;n agregada o de car&aacute;cter estad&iacute;stico. En http://www.ajusath.es se utilizan para esta finalidad, las cookies de Google Analytics que tienen distintos plazos de caducidad en función de la informaci&oacute;n que ofrecen a la Entidad.</li>
     </ul>
     <br />
     <br />
     <strong>3. &iquest;Qui&eacute;n utiliza las cookies?</strong><br />
     <br />
     La informaci&oacute;n que se recaba a trav&eacute;s de las cookies de http://www.ajusath.es puede ser utilizada tanto por el titular de la p&aacute;gina web como por un tercero que preste un servicio al titular (por ejemplo, &quot;Google&quot;).<br />
     <br />
     <strong>4. Gesti&oacute;n de las cookies.</strong><br />
     <br />
     Teniendo en cuenta la informaci&oacute;n facilitada a trav&eacute;s de la presente Pol&iacute;tica de Cookies, a continuaci&oacute;n le ofrecemos informaci&oacute;n sobre c&oacute;mo puede llevar a cabo la gesti&oacute;n de las cookies utilizadas en http://www.ajusath.es a través de las diferentes opciones que ofrecen los navegadores m&aacute;s comunes (Explorer, Firefox y Chrome).<br />
     <br />
     Si se impide la instalaci&oacute;n de todas las cookies de la p&aacute;gina web, algunas funcionalidades de la misma, as&iacute; como algunos contenidos pueden verse afectados.<br />
     <br />
     <strong>4.1. Como visualizar las cookies.</strong><br />
     <br />
     Todos los navegadores ofrecen al usuario la posibilidad de buscar y visualizar las cookies que instala un determinado sitio web, obtener informaci&oacute;n relativa a la duraci&oacute;n de las mismas y la posibilidad de eliminarlas, tal y como se indica en el siguiente apartado. A continuaci&oacute;n, se muestran una serie de enlaces informativos sobre esta cuesti&oacute;n de los navegadores m&aacute;s utilizados: <br />
     <br />
     <ul>
       <li>Google Chrome: https://support.google.com/chrome/answer/95647?hl=es</li>
       <li>Mozilla Firefox: https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-</li>
       <li>Internet Explorer: http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9</li>
     </ul>
     <br />
     <br />
     <strong>4.2.Como eliminar las cookies.</strong><br />
     <br />
     Para restringir o bloquear las cookies, usted deber&aacute; modificar la configuraci&oacute;n del navegador que utilice en su terminal, ya sea ordenador, smartphone o tablet. Con car&aacute;cter general los navegadores ofrecen las siguientes opciones de configuraci&oacute;n en relaci&oacute;n a la instalaci&oacute;n de cookies:<br />
     <br />
     <ul>
       <li>Que el navegador rechace todas las cookies y por lo tanto, que no se instale ninguna cookie de ninguna p&aacute;gina web en su terminal.</li>
       <li>Que el navegador le avise antes de que se produzca la instalaci&oacute;n de la cookie para que usted decida si acepta o no la instalaci&oacute;n de la misma.</li>
       <li>Que el navegador &uacute;nicamente rechace las cookies de terceros de los sitios web que visita pero no las utilizadas por el sitio web por el que usted navega.</li>
       <li>La opci&oacute;n de navegaci&oacute;n en modo privado mediante la cual, las cookies se instalan en el terminal pero se elimina de manera autom&aacute;tica cuando finaliza la navegaci&oacute;n por la p&aacute;gina web:
         <ul>
           <li>Google Chrome: https://support.google.com/chrome/answer/95464?hl=es</li>
           <li>Mozilla Firefox: https://support.mozilla.org/es/kb/navegacion-privada-navega-en-la-web-sin-guardar-in?redirectlocale=en-US&amp;as=u&amp;redirectslug=Private+Browsing&amp;utm_source=inproduct</li>
           <li>Internet Explorer: http://windows.microsoft.com/es-ES/windows-8/help-protect-yourself-ie-10?ocid=IE10_priv_browsing#firstTabControl=tab1</li>
         </ul>
       </li>
     </ul>
     <br />
     <br />
     <strong>5. Oposici&oacute;n del usuario al uso de cookies.</strong><br />
     <br />
     En caso de que el usuario se oponga al uso de cookies propias o de terceros en http://www.ajusath.es es posible que &eacute;ste no pueda acceder a todas las funcionalidades que el sitio web ofrece.
   </div>
 </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped  >
.politica-de-cookies {
  .title{
    color: #054279;
  }
  strong{
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue